import styles from './Card.module.css';



const Card = (props) => {
   return (
      <div className={styles.card}>
         <a href="#!" className={styles.card__link}>
            <img className={styles.card__img} src={props.img} alt="" />
            <div className={styles.card__title}>{props.title}</div>
            <div className={styles.card__text}>Explore Now!</div>
         </a>
      </div>
   );
}

export default Card;